import React from 'react'

function Landing() {

    return (
      <div className='landing-page'>
        <div className='component-page'>
          <div className='landing-body-left'>
            <div className='title-1'>CLK</div>
            <div className='title-line'></div>
            <div className='title-2'>Pyschotherapy</div>
          </div>
          <div className='landing-body-right'>
          </div>
        </div>
      </div>
    )
}

export default Landing